import createIcon from '../../createIcon';

/**
 * @component @name Straighten
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgNkgzQzEuOSA2IDEgNi45IDEgOFYxNkMxIDE3LjEgMS45IDE4IDMgMThIMjFDMjIuMSAxOCAyMyAxNy4xIDIzIDE2VjhDMjMgNi45IDIyLjEgNiAyMSA2Wk0yMSAxNkgzVjhINVYxMkg3VjhIOVYxMkgxMVY4SDEzVjEySDE1VjhIMTdWMTJIMTlWOEgyMVYxNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Straighten = createIcon('Straighten', [
  [
    'path',
    {
      d: 'M21 6H3C1.9 6 1 6.9 1 8V16C1 17.1 1.9 18 3 18H21C22.1 18 23 17.1 23 16V8C23 6.9 22.1 6 21 6ZM21 16H3V8H5V12H7V8H9V12H11V8H13V12H15V8H17V12H19V8H21V16Z',
      key: '1vttz1',
    },
  ],
]);

export default Straighten;
